import React from "react";
import PropTypes from 'prop-types';
import OfferChoiceSummaryCellAdditionalRound from "../../offerChoice/components/additionalRound/OfferChoiceSummaryCellAdditionalRound";
import {AdditionalRoundStatusesPending} from "constants/AdditionalRoundStatus";
import Tr from 'translations/Translations'
import BoldTypography from "components/BoldTypography";


function AdditionalRoundPassiveStatusCell(
    {
        demandId,
        additionalRound,
        setRowWorking,
        rowWorking,
        refreshRow,
        serverBrowserTimeDiff,
        working,
        editable
    }) {


    return (
        AdditionalRoundStatusesPending.indexOf(additionalRound.status) > -1 ?
            <OfferChoiceSummaryCellAdditionalRound
                demandId={demandId}
                roundName={additionalRound.name}
                additionalRoundId={additionalRound.roundId}
                setRowWorking={setRowWorking}
                rowWorking={rowWorking}
                refreshRow={refreshRow}
                working={working}
                serverBrowserTimeDiff={serverBrowserTimeDiff}
                additionalRoundStatus={additionalRound.status}
                editable={editable}
                additionalRoundOpenOfferDate={additionalRound.openOfferDate}
                additionalRoundEndDate={additionalRound.endDate}
            />
            :
            <BoldTypography align='center'>{Tr('additional_offer_collection_finished')}</BoldTypography>
    )
}

AdditionalRoundPassiveStatusCell.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    editable: PropTypes.bool.isRequired,
    working: PropTypes.bool.isRequired,
    additionalRound: PropTypes.object.isRequired,
    setRowWorking: PropTypes.func.isRequired,
    refreshRow: PropTypes.func.isRequired,
    rowWorking: PropTypes.bool.isRequired,
    serverBrowserTimeDiff: PropTypes.object.isRequired,
}

export default AdditionalRoundPassiveStatusCell;

